/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { ASSIGNMENT_PATH, READ_ASSIGNMENTS_LIST, READ_ASSIGNMENT, useAssignmentRoute } from 'domain/shared/assignment';
import AssignmentList from 'domain/staffing/assignment/List';
import ViewAssignment from 'domain/staffing/assignment/Show';
import { Route } from 'framework/routing';
import { ProtectedRouter } from 'infrastructure/routing';
import AssignmentContext from 'domain/staffing/assignment/AssignmentContext';

const AssignmentRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute, singleEntityRoute } = useAssignmentRoute();

  return (
    <ProtectedRouter basePath={ASSIGNMENT_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_ASSIGNMENTS_LIST}>
              <AssignmentList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={singleEntityRoute}
          element={
            <AssignmentContext permissionToCheck={READ_ASSIGNMENT}>
              <ViewAssignment />
            </AssignmentContext>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

AssignmentRouter.getRouterPath = () => `${ASSIGNMENT_PATH}/*`;

export default AssignmentRouter;
